<!--suppress AngularNgOptimizedImage -->
<div class="tutor-dialog">

  <div class="dialog-header">
    <div class="title">
      <mat-icon>supervisor_account</mat-icon>
      CREAR TUTOR
    </div>
    <div class="subtitle">
      EL TUTOR DEBE SER MAYOR DE EDAD.
    </div>
  </div>

  <div class="dialog-body">
    <div class="card px-4 py-4">

      <!-- ===== FORM USER ===== -->
      <form [formGroup]="userForm" autocomplete="off">
        <div class="seccion-formulario">
          <div class="titulo-seccion">
            <mat-icon>lock</mat-icon>
            DATOS DE ACCESO
          </div>
          <div class="descripcion-seccion">
            CREDENCIALES QUE USARA EL TUTOR PARA INGRESAR AL SISTEMA
          </div>

          <div class="row">
            <div class="col-md-4 mb-2">
              <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                <mat-label>USUARIO</mat-label>
                <input autocomplete="nope" formControlName="usr" matInput required />
              </mat-form-field>

              <div *ngIf="userForm.get('usr')?.touched && userForm.get('usr')?.invalid" class="custom-error-below">
                <small *ngIf="userForm.get('usr')!.hasError('required')" class="text-danger">
                  EL NOMBRE DE USUARIO ES OBLIGATORIO.
                </small>
                <small *ngIf="userForm.get('usr')!.hasError('pattern')" class="text-danger">
                  SOLO LETRAS, NUMEROS, ESPACIOS, PUNTOS, GUIONES Y GUIONES BAJOS.
                </small>
              </div>
            </div>

            <div class="col-md-8 mb-2">
              <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                <mat-label>CORREO ELECTRONICO</mat-label>
                <input autocomplete="nope" email formControlName="email" matInput required />
              </mat-form-field>

              <div *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid" class="custom-error-below">
                <small *ngIf="userForm.get('email')!.hasError('required')" class="text-danger">
                  EL CORREO ELECTRONICO ES OBLIGATORIO.
                </small>
                <small *ngIf="userForm.get('email')!.hasError('pattern')" class="text-danger">
                  INGRESE UNA DIRECCION DE CORREO VALIDA.
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="seccion-formulario">
          <div class="titulo-seccion">
            <mat-icon>person</mat-icon>
            DATOS GENERALES
          </div>
          <div class="descripcion-seccion">
            INFORMACION GENERAL DE CONTACTO Y DOMICILIO
          </div>

          <div class="row">
            <div class="col-md-6 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>NOMBRE(S)</mat-label>
                <input appUppercaseNoAccent autocomplete="nope" formControlName="nombres" matInput required />
              </mat-form-field>
              <div *ngIf="userForm.get('nombres')?.touched && userForm.get('nombres')?.invalid" class="custom-error-below">
                <small *ngIf="userForm.get('nombres')!.hasError('required')" class="text-danger">
                  EL CAMPO NOMBRES ES OBLIGATORIO.
                </small>
                <small *ngIf="userForm.get('nombres')!.hasError('pattern')" class="text-danger">
                  SOLO SE PERMITEN LETRAS Y ESPACIOS.
                </small>
              </div>
            </div>

            <div class="col-md-6 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>PRIMER APELLIDO</mat-label>
                <input appUppercaseNoAccent autocomplete="nope" formControlName="primerApellido" matInput required />
              </mat-form-field>
              <div *ngIf="userForm.get('primerApellido')?.touched && userForm.get('primerApellido')?.invalid" class="custom-error-below">
                <small *ngIf="userForm.get('primerApellido')!.hasError('required')" class="text-danger">
                  EL PRIMER APELLIDO ES OBLIGATORIO.
                </small>
                <small *ngIf="userForm.get('primerApellido')!.hasError('pattern')" class="text-danger">
                  SOLO SE PERMITEN LETRAS Y ESPACIOS.
                </small>
              </div>
            </div>

            <div class="col-md-6 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>SEGUNDO APELLIDO</mat-label>
                <input appUppercaseNoAccent autocomplete="nope" formControlName="segundoApellido" matInput required />
              </mat-form-field>
              <div *ngIf="userForm.get('segundoApellido')?.touched && userForm.get('segundoApellido')?.invalid" class="custom-error-below">
                <small *ngIf="userForm.get('segundoApellido')!.hasError('required')" class="text-danger">
                  EL SEGUNDO APELLIDO ES OBLIGATORIO.
                </small>
                <small *ngIf="userForm.get('segundoApellido')!.hasError('pattern')" class="text-danger">
                  SOLO SE PERMITEN LETRAS Y ESPACIOS.
                </small>
              </div>
            </div>

            <div class="col-md-6 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>TELEFONO MOVIL</mat-label>
                <ngx-mat-intl-tel-input
                  formControlName="movil"
                  [preferredCountries]="preferredCountries"
                  [enablePlaceholder]="true">
                </ngx-mat-intl-tel-input>
              </mat-form-field>
              <div *ngIf="userForm.get('movil')?.touched && userForm.get('movil')!.hasError('required')" class="custom-error-below">
                <small class="text-danger">EL NUMERO DE CELULAR ES OBLIGATORIO.</small>
              </div>
            </div>

            <!-- CP / Colonia -->
            <div class="col-md-6 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>
                  {{ (userForm.get('settlementSearch')?.value ? 'COLONIA' : 'CODIGO POSTAL') | regionWord }}
                </mat-label>

                <input
                  matInput
                  [matAutocomplete]="auto"
                  formControlName="settlementSearch"
                  (blur)="onSettlementBlur()"
                  autocomplete="nope" />

                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="setSelectedSettlement($event.option.value)"
                  [displayWith]="displayFn">
                  <mat-option *ngFor="let option of settlements" [value]="option">
                    {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')!.hasError('required')" class="custom-error-below">
                <small class="text-danger">EL CODIGO POSTAL ES OBLIGATORIO.</small>
              </div>
              <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')!.hasError('pattern')" class="custom-error-below">
                <small class="text-danger">INGRESA UN CODIGO POSTAL VALIDO.</small>
              </div>
            </div>

            <div class="col-md-6 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>DIRECCION</mat-label>
                <textarea appUppercaseNoAccent autocomplete="nope" formControlName="domicilio" matInput required></textarea>
              </mat-form-field>
              <div *ngIf="userForm.get('domicilio')?.touched && userForm.get('domicilio')?.invalid" class="custom-error-below">
                <small *ngIf="userForm.get('domicilio')!.hasError('required')" class="text-danger">
                  EL DOMICILIO ES OBLIGATORIO.
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- EMPRESA -->
        <div class="seccion-formulario" *ngIf="!isDoctor && (!isParticular || showSucursalSelectForParticular)">
          <div class="titulo-seccion">
            <mat-icon>business</mat-icon>
            EMPRESA
          </div>
          <div class="descripcion-seccion">
            SELECCIONA EL GRUPO EMPRESARIAL Y SUCURSAL
          </div>

          <div class="row">
            <div class="col-md-6 mb-2" *ngIf="!isParticular">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>GRUPO EMPRESARIAL</mat-label>
                <mat-select (selectionChange)="getBranchesByGemp()" formControlName="idGEMP" required>
                  <mat-option *ngFor="let row of businessGroups" [value]="row.idGEMP">
                    {{ row.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              class="mb-2"
              *ngIf="!isParticular || showSucursalSelectForParticular"
              [ngClass]="isParticular ? 'col-md-12' : 'col-md-6'">

              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>SUCURSAL</mat-label>
                <mat-select formControlName="idSucursal" required>
                  <mat-option *ngFor="let row of branches" [value]="row.idSucursal">
                    {{ row.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>

      <!-- ===== FORM PATIENT (Tutor) ===== -->
      <form [formGroup]="patientForm" autocomplete="off">
        <div class="seccion-formulario">
          <div class="titulo-seccion">
            <mat-icon>fingerprint</mat-icon>
            DATOS ADICIONALES
          </div>
          <div class="descripcion-seccion">
            EL TUTOR DEBE SER MAYOR DE EDAD.
          </div>

          <div class="row">
            <div class="col-md-4 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>FECHA DE NACIMIENTO</mat-label>
                <input [matDatepicker]="picker" [max]="maxBirthDate" formControlName="fechaNacimiento" matInput required>
                <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <div *ngIf="patientForm.get('fechaNacimiento')?.touched && patientForm.get('fechaNacimiento')?.invalid" class="custom-error-below">
                <small *ngIf="patientForm.get('fechaNacimiento')!.hasError('required')" class="text-danger">
                  LA FECHA DE NACIMIENTO ES OBLIGATORIA.
                </small>
                <small *ngIf="patientForm.get('fechaNacimiento')!.hasError('maxDate')" class="text-danger">
                  LA FECHA DE NACIMIENTO NO PUEDE SER POSTERIOR A HOY.
                </small>
                <small *ngIf="patientForm.get('fechaNacimiento')!.hasError('minAge')" class="text-danger">
                  EL TUTOR DEBE SER MAYOR DE EDAD (18+).
                </small>
              </div>
            </div>

            <div class="col-md-4 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>GENERO</mat-label>
                <mat-select formControlName="genero" required>
                  <mat-option value="F">FEMENINO</mat-option>
                  <mat-option value="M">MASCULINO</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-4 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>ENTIDAD DE NACIMIENTO</mat-label>
                <mat-select formControlName="idEntidadNacimiento" required>
                  <mat-option *ngFor="let row of federalEntity" [value]="row.idEntidad">
                    {{ row.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-6 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>TIPO DE IDENTIFICACION</mat-label>
                <mat-select
                  formControlName="idTipoIdentificacion"
                  required
                  (selectionChange)="onTipoIdentificacionChange()">
                  <mat-option [value]="ID_TIPO_IDENTIFICACION_SIN_ASIGNAR">SIN ASIGNAR</mat-option>
                  <mat-option [value]="ID_TIPO_IDENTIFICACION_PASAPORTE">PASAPORTE</mat-option>
                  <mat-option [value]="ID_TIPO_IDENTIFICACION_DOCUMENTO">{{ documentoIdentidadLabel }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-6 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>NUMERO DE IDENTIFICACION</mat-label>
                <input
                  appUppercaseNoAccent
                  autocomplete="nope"
                  formControlName="numeroIdentificacion"
                  matInput
                  required
                  [readonly]="numeroIdentificacionReadonly" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>

      <!-- ===== ASSET ===== -->
      <form [formGroup]="archiveForm" autocomplete="off">
        <div class="seccion-formulario">
          <div class="titulo-seccion">
            <mat-icon>settings</mat-icon>
            CONFIGURACION
          </div>

          <label class="fw-semibold">IMAGEN DE PERFIL (JPG, PNG, JPEG)</label>
          <app-file-upload
            formControlName="imagen"
            [acceptedTypes]="'image/*'"
            [externalSrc]="null"
            [circle]="true"
            [targetKB]="10"
            [initialMaxSize]="320">
          </app-file-upload>
        </div>
      </form>

    </div>
  </div>

  <div class="dialog-footer">
    <button mat-stroked-button color="primary" type="button" (click)="cancelar()">
      CANCELAR
    </button>

    <button mat-raised-button color="primary" type="button" (click)="guardarTutor()">
      GUARDAR TUTOR
    </button>
  </div>

</div>
